import { Badge } from 'antd'
import { useTranslation } from 'react-i18next'

export function ComplaintStateBadgeRibbon ({ state, ...props }) {
  const i18n = useTranslation('translation', { keyPrefix: 'common.resources.complaint.values.state' })
  const text = i18n.t(`${state}.label`)
  const color = i18n.t(`${state}.color`)
  return <Badge.Ribbon color={color} text={text} {...props} />
}
